/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    // all the layers has it's (0,0) at the top-left corner of the middle 720x720 area. means (360, 360) in each layer will be the center of the screen.
    SCREENS = "screens",
    SCREEN_SHOOT = "screenShoot",
    WIN_COUNT_UP = "winCountUp",
    BIG_WIN = "bigWin",
    WIN_TEXTS = "winTexts",
    WIN_PRESENTATIONS = "winPresentations",
    FOREGROUND_HOLE = "foreground_hole",
    FOREGROUND_TOP = "foreground_top",
    BACKGROUND_IDLE_FOREGROUND = "backgroundIdleForeGround",
    NEAR_WIN = "nearWin",
    FOREGROUND = "foreground",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    HIGH_SYMBOLS = "high_symbols",
    LOW_SYMBOLS = "low_symbols",
    REEL_BACKGROUND = "reel_background",
    BACKGROUND_FOREGROUND = "backroundForeground",
    BACKGROUND_IDLE = "backgroundIdle",
    BACKGROUND = "background",
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize():void {
        this.children.forEach((c:any) => {
            if(c.onResize) {
                c.onResize();
            }
        });
    }

    public onOrientationChanged():void {
        this.children.forEach((c:any) => {
            if(c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        });
    }

    public addChild<T extends PIXI.DisplayObject>(...children:T[]):T {
        children.forEach((c:any) => {
            if(c.onResize) {
                c.onResize();
            }
            if(c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        })

        return super.addChild(...children);
    }
}

export class DeadwoodRipLayers {

    constructor() {
        for(const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name:string):StageLayer | undefined {
        return NolimitApplication.getLayerByName(name);
    }
}